// src/cert/vapt.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const VAPT = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>VAPT प्रमाणन</h1>
                <p>भेद्यता मूल्यांकन आणि पेनेट्रेशन टेस्टिंग (Vulnerability Assessment & Penetration Testing)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>VAPT म्हणजे काय?</h2>
                    <p>
                        Network Infrastructure VAPT

                        Network security testing, specifically the Network Infrastructure VAPT, plays a crucial role in identifying security issues, pinpointing network devices vulnerable to known threats, and uncovering weak links within your network. This comprehensive assessment and penetration testing procedure thoroughly examine your network, enabling the detection and mitigation of potential vulnerabilities.

                        Web and Mobile application VAPT

                        Protect your web and mobile applications against security threats with CloudIBN providing the best expert managed services. For web app, we focus on OWASP Top 10 and NIST CWE. For mobile apps, we ensure PCI DSS compliance, conduct network and app layer testing, and use static, dynamic, and forensic tools to identify and mitigate risks. Our complete Web and Mobile App VAPT service is essential for identifying and addressing security vulnerabilities.

                        Cloud Infrastructure VAPT

                        IT infrastructure testing, specifically Cloud Infrastructure VAPT, involves a comprehensive examination of the cloud architecture. This assessment aims to uncover potential attack vectors within the IT infrastructure, encompassing everything from the network layer of the cloud design to the virtual data centers housing the cloud applications.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>सायबर हल्ले, डेटा चोरी रोखता येतात</li>
                        <li>PCI DSS, ISO 27001, GDPR अनुपालन</li>
                        <li>वेबसाईट, अॅप, नेटवर्कमधील कमकुवत भाग शोधले जातात</li>
                        <li>नियमित चाचणीसाठी अहवाल आणि उपाय सुचवले जातात</li>
                        <li>संस्थेची विश्वासार्हता आणि ग्राहकांचा विश्वास वाढतो</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>VAPT साठी अर्ज करा</h2>
                    <ApplyForm certification="VAPT" />
                </section>
            </div>
        </div>
    );
};

export default VAPT;